import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { TableModule } from 'primeng/table'
import { Dropdown, DropdownModule } from 'primeng/dropdown'
import { Select, SelectModule } from 'primeng/select'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { SpinnerComponent } from './components/spinner/spinner.component'
import { VCInputDirective } from './directives/vc-input.directive'
import { OrdinalPipe } from './pipes/ordinal.pipe'
import { PracticeSelectComponent } from './components/practice-select/practice-select.component'
import { HospitalInfoRowComponent } from './components/hospital-info-row/hospital-info-row.component'
import { HospitalKPIRowComponent } from './components/hospital-kpi-row/hospital-kpi-row.component'
import { KPICardComponent } from './components/kpi-card/kpi-card.component'
import { ZohoTicketModalComponent } from './components/zoho-ticket-modal/zoho-ticket-modal.component'
import { DropdownButtonComponent } from './components/dropdown-button/dropdown-button.component'
import { DVMFeedbackRowComponent } from './components/dvm-feedback-row/dvm-feedback-row.component'
import { DvmMedicalInterestsComponent } from './components/dvm-medical-interests/dvm-medical-interests.component'
import { SingleSelectDropdownComponent } from './components/single-select-dropdown/single-select-dropdown.component'
import { CheckboxModule } from 'primeng/checkbox'
import { InputTextModule } from 'primeng/inputtext'
import { CardModule } from 'primeng/card'
import { RadioButtonModule } from 'primeng/radiobutton'
import { AutoCompleteModule } from 'primeng/autocomplete'
import { ButtonModule } from 'primeng/button'
import { VcTextInputComponent } from './components/text-input/text-input.component'
import { PhonePipe } from './pipes/phone.pipe'
import { HospitalInfoColumnComponent } from './components/hospital-info-column/hospital-info-column.component'
import { NgApexchartsModule } from 'ng-apexcharts'
import { VetcorPricingModule } from '../vetcor-pricing/vetcor-pricing.module'
import { BookingModalComponent } from './components/booking-modal/booking-modal.component'
import { MeetingSchedulerComponent } from './components/meeting-scheduler/meeting-scheduler.component'
import { MeetingSchedulerModalComponent } from './components/meeting-scheduler-modal/meeting-scheduler-modal.component'
import { VcTextareaComponent } from './components/textarea/textarea.component'
import { VcSearchInputComponent } from './components/search-input/search-input.component'
import { VcRoundedCardComponent } from './components/rounded-card/rounded-card.component'
import { VcRadioGroupComponent } from './components/radio-group/radio-group.component'
import { VcMultiSelectComponent } from './components/multi-select/multi-select.component'
import { VcDetailListComponent } from './components/detail-list/detail-list.component'
import { VcCheckboxComponent } from './components/checkbox/checkbox.component'
import { InputTextarea } from 'primeng/inputtextarea'
import { MultiSelectModule } from 'primeng/multiselect'
import { TooltipModule } from 'primeng/tooltip'
import { RippleModule } from 'primeng/ripple'
import { FormatCurrencyPipe } from './pipes/format-currency.pipe'
import { ClientVerificationCardComponent } from './components/client-verification-card/client-verification-card.component'
import { ClientVerificationModalComponent } from './components/client-verification-modal/client-verification-modal.component'
import { ClientVerificationRowsComponent } from './components/client-verification-modal/client-verification-rows.component'
import { FileUploadComponent } from './components/file-upload/file-upload.component'
import { MessageModule } from 'primeng/message'
import { MessagesModule } from 'primeng/messages'
import { FileUploadModule } from 'primeng/fileupload'
import { RouterModule } from '@angular/router'
import { ProgressSpinnerModule } from 'primeng/progressspinner'
import { CalendarModule } from 'primeng/calendar'
import { DatePickerModule } from 'primeng/datepicker'

@NgModule({
   declarations: [
      SpinnerComponent,
      PracticeSelectComponent,
      HospitalInfoRowComponent,
      HospitalKPIRowComponent,
      KPICardComponent,
      ZohoTicketModalComponent,
      OrdinalPipe,
      SingleSelectDropdownComponent,
      DVMFeedbackRowComponent,
      DvmMedicalInterestsComponent,
      VcTextInputComponent,
      PhonePipe,
      HospitalInfoColumnComponent,
      BookingModalComponent,
      MeetingSchedulerComponent,
      MeetingSchedulerModalComponent,
      VcTextareaComponent,
      VcSearchInputComponent,
      VcRoundedCardComponent,
      VcRadioGroupComponent,
      VcMultiSelectComponent,
      VcDetailListComponent,
      VcCheckboxComponent,
      FormatCurrencyPipe,
      ClientVerificationCardComponent,
      ClientVerificationModalComponent,
      ClientVerificationRowsComponent,
      FileUploadComponent,
      VcRadioGroupComponent,
      VcCheckboxComponent,
   ],
   imports: [
      DropdownButtonComponent,
      VCInputDirective,
      CommonModule,
      TableModule,
      DropdownModule,
      SelectModule,
      FormsModule,
      ReactiveFormsModule,
      InputTextModule,
      CheckboxModule,
      CardModule,
      RadioButtonModule,
      ButtonModule,
      NgApexchartsModule,
      AutoCompleteModule,
      ButtonModule,
      InputTextarea,
      MultiSelectModule,
      TooltipModule,
      RippleModule,
      MessagesModule,
      MessageModule,
      FileUploadModule,
      ProgressSpinnerModule,
      CalendarModule,
      DatePickerModule,
   ],
   exports: [
      Dropdown,
      Select,
      DropdownButtonComponent,
      SpinnerComponent,
      PracticeSelectComponent,
      HospitalInfoRowComponent,
      HospitalKPIRowComponent,
      SingleSelectDropdownComponent,
      DVMFeedbackRowComponent,
      KPICardComponent,
      ZohoTicketModalComponent,
      OrdinalPipe,
      DvmMedicalInterestsComponent,
      VcTextInputComponent,
      PhonePipe,
      HospitalInfoColumnComponent,
      BookingModalComponent,
      MeetingSchedulerComponent,
      MeetingSchedulerModalComponent,
      VcTextareaComponent,
      VcSearchInputComponent,
      VcRoundedCardComponent,
      VcRadioGroupComponent,
      VcMultiSelectComponent,
      VcDetailListComponent,
      VcCheckboxComponent,
      ClientVerificationCardComponent,
      ClientVerificationModalComponent,
      ClientVerificationRowsComponent,
      FormatCurrencyPipe,
      ClientVerificationCardComponent,
      ClientVerificationModalComponent,
      ClientVerificationRowsComponent,
      FileUploadComponent,
   ],
})
export class SharedModule {}
